import {useProductDealsContext} from '../contexts/ProductDealsContext';
import React, {useEffect, useMemo} from 'react';
import {useErrorLoadingState} from '../../helpers/hooks/useErrorLoadingState';
import {useProductDetailContext} from '../contexts/ProductDetailContext';
import {ProductPurchasePanelUI} from '../ui/PurchasePanelUI';
import {usePurchaseLogic} from '../hooks/usePurchaseLogic';

export const useProductPurchasePanelState = () => {
  const { productDetails } = useProductDetailContext();
  const { productDeals, loadDeals } = useProductDealsContext();
  const { loading, error, run } = useErrorLoadingState(true);

  const {
    dealSelection,
    price,
    quantity,
    discount,
    bcDiscounts,
    setDealSelection,
    setQuantity
  } = usePurchaseLogic({
    productDeals
  });

  useEffect(() => {
    if (!!productDetails) {
      run(loadDeals, [productDetails.pro_codigo]);
    }
  }, [productDetails]);

  return useMemo(() => (
    {
      productDeals,
      loading,
      error,
      dealSelection,
      onDealSelectionChange: setDealSelection,
      quantity,
      onQuantityChange: setQuantity,
      price,
      discount,
      bcDiscounts,
      details: productDetails,
    }
  ), [
    bcDiscounts,
    dealSelection,
    discount,
    error,
    loading,
    setQuantity,
    price,
    productDeals,
    productDetails,
    quantity,
    setDealSelection
  ]);
};

export const ProductPurchasePanel = () => {
  const { productDetails } = useProductDetailContext();
  const { productDeals, loadDeals } = useProductDealsContext();

  const {
    loading,
    error,
    dealSelection,
    onDealSelectionChange,
    quantity,
    onQuantityChange,
    price,
    discount,
    bcDiscounts,
  } = useProductPurchasePanelState({ productDetails, productDeals, loadDeals });

  return (
    <ProductPurchasePanelUI
      data={{
        deals: productDeals,
        loading: loading,
        error: error,
        dealSelection: dealSelection,
        quantity: quantity,
        price: price,
        discount: discount,
        bcDiscounts: bcDiscounts,
        details: productDetails,
      }}
      actions={{
        onQuantityChange: onQuantityChange,
        onDealSelectionChange: onDealSelectionChange
      }}
    />
  );
};